import { render, staticRenderFns } from "./SelectSelectedScope.vue?vue&type=template&id=ab8f5964&scoped=true&"
import script from "./SelectSelectedScope.vue?vue&type=script&lang=js&"
export * from "./SelectSelectedScope.vue?vue&type=script&lang=js&"
import style0 from "./SelectSelectedScope.vue?vue&type=style&index=0&id=ab8f5964&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8f5964",
  null
  
)

export default component.exports